import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import { useMemo } from 'react';
import { css, useTheme, jsx } from '@emotion/react';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import { devWarning, utilStyles } from '@paypalcorp/pp-react-utils';

var _templateObject, _templateObject2, _templateObject3;
function styles(tokens) {
  /* istanbul ignore next */
  if (!Object.keys(tokens).length) {
    devWarning('Missing Emotion theme. Use ThemeProvider from @emotion/react to pass a valid theme from pp-react.');
    return {};
  }

  var _utilStyles = utilStyles(tokens),
      screenReader = _utilStyles.screenReader;

  var appbadgeHeight = '2.5rem';
  var base = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    label: appbadge_base;\n    line-height: 0;\n  "])));
  var ios = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    label: ios;\n    height: ", ";\n    width: ", ";\n    vertical-align: bottom;\n  "])), appbadgeHeight, '7.5rem');
  var android = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    label: android;\n    height: ", ";\n    width: ", ";\n    vertical-align: bottom;\n  "])), appbadgeHeight, '8.4375rem');
  return {
    base: base,
    ios: ios,
    android: android,
    screenReader: screenReader
  };
}

var _excluded = ["url", "platform", "locale", "className", "imageClassName", "cdnHost", "children"];
var DEFAULT_LOCALE = 'en-US'; //@ts-ignore

var getImageSources = function (currentLocale, cdnHost) {
  var localeFormat = currentLocale.toString().replace('-', '_');
  return {
    locale: localeFormat,
    ios: "https://".concat(cdnHost, "/appbadges/badges/").concat(localeFormat, "/ios.svg"),
    ios_white: "https://".concat(cdnHost, "/appbadges/badges/").concat(localeFormat, "/ios_white.svg"),
    android: "https://".concat(cdnHost, "/appbadges/badges/").concat(localeFormat, "/android-no-padding.svg")
  };
};

var Appbadge = function (_ref) {
  var url = _ref.url,
      platform = _ref.platform,
      _ref$locale = _ref.locale,
      locale = _ref$locale === void 0 ? DEFAULT_LOCALE : _ref$locale,
      className = _ref.className,
      imageClassName = _ref.imageClassName,
      _ref$cdnHost = _ref.cdnHost,
      cdnHost = _ref$cdnHost === void 0 ? 'www.paypalobjects.com' : _ref$cdnHost,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  /* istanbul ignore next */
  if (!url) {
    devWarning('Required prop `url` is missing.');
  }

  var tokens = useTheme();

  var _styles = useMemo(function () {
    return styles(tokens);
  }, [tokens]);

  var imageCssVal = platform === "android" ? _styles.android : _styles.ios;
  var image = useMemo(function () {
    return getImageSources(locale, cdnHost);
  }, [locale]); //@ts-ignore

  var imgsource = image[platform];
  return jsx("a", _extends({
    href: url,
    css: _styles.base,
    className: className,
    "data-ppui-info": "appbadge_2.3.2"
  }, rest), jsx("span", {
    css: _styles.screenReader,
    "data-ppui": "true"
  }, children), jsx("img", {
    alt: platform,
    css: imageCssVal,
    className: imageClassName,
    src: imgsource,
    "aria-hidden": "true",
    "data-ppui": "true"
  }));
};

export { Appbadge, styles as appBadgeStyles, getImageSources };
